export const accordianParent =
  "max-w-[1200px] md:mt-20 mt-10 flex md:flex-row flex-col flex-wrap";
export const countryHeader =
  "w-[120px] font-extrabold text-center bg-green text-white text-lg my-8 first:mt-0 uppercase md:pl-0";
export const countryContainer = "flex flex-wrap flex-col md:flex-row md:ml-10";
export const containerStyles =
  "flex flex-col items-center justify-center w-full text-black";
export const staffContainer = "flex flex-wrap justify-center w-full";
export const staffChildContainer = "flex md:w-[1200px] flex-wrap justify-around md:justify-center my-16"
export const whoContainer = "flex flex-wrap md:my-20 my-12 px-4 max-w-[550px] text-center text-xl"